import { render, staticRenderFns } from "./ChannelCard.vue?vue&type=template&id=5633beeb&scoped=true"
import script from "./ChannelCard.vue?vue&type=script&lang=js"
export * from "./ChannelCard.vue?vue&type=script&lang=js"
import style0 from "./ChannelCard.vue?vue&type=style&index=0&id=5633beeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633beeb",
  null
  
)

export default component.exports